import { OverlayArrow } from 'react-aria-components';
import clsx from 'clsx';

import styles from './TooltipArrow.module.css';

type Props = {
  theme?: 'light' | 'dark' | 'white';
};

export function TooltipArrow({ theme = 'dark' }: Props) {
  if (theme === 'white') {
    // The popover's own arrow (`popover/Popover.tsx`), so the white theme matches it: a 12px
    // outlined chevron rather than the tooltip's filled 7px triangle.
    return (
      <OverlayArrow className={styles.popoverArrow}>
        <svg width={12} height={12} viewBox="0 0 12 12">
          <path d="M0 0 L6 6 L12 0" />
        </svg>
      </OverlayArrow>
    );
  }
  return <OverlayArrow className={clsx(styles.arrow, styles[theme])} />;
}
